import { AccountProduct } from '@libs/common-types';

export interface FavoriteItemPrice {
    currencyCode: string;
    centAmount: number;
    fractionDigits: number;
}

export enum ProductStatus {
    discontinued = 'discontinued',
    outOfStock = 'outOfStock',
    addToCartSTH = 'addToCartSTH',
    addToCartInStore = 'addToCartInStore',
    addToCartRedirectPDP = 'addToCartRedirectPDP',
}

export interface FavoriteItem {
    productKey: string;
    productSlug: string;
    sku: string;
    storeId?: string | null;
    name: string;
    descriptionShort: string;
    descriptionLong: string;
    isDiscontinued: boolean;
    primaryCategoryId: string;
    url: string;
    images: {
        large?: string;
        small?: string;
    };
    status: ProductStatus;
    listPrice?: FavoriteItemPrice;
    basePrice?: FavoriteItemPrice;
    brand: string;
    category: string;
    subCategory1: string;
    subCategory2: string;
    pharmacyType: string;
    color?: string;
    size?: string;
    flavor?: string;
    customCaseQuantity?: number;
    bopisCaseQty?: number;
    isCaseRequired?: boolean;
    vicePresidentName?: string;
    hierarchyDivision?: string;
    hierarchyDepartment?: string;
    hierarchyClass?: string;
    hierarchyCategory?: string;
}

export interface FavoriteItemsSuccessResponse {
    items: AccountProduct[];
}
